import { render, staticRenderFns } from "./PepViewCardLegado.vue?vue&type=template&id=62f8a9d5&"
import script from "./PepViewCardLegado.vue?vue&type=script&lang=js&"
export * from "./PepViewCardLegado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports